import { createSlice } from '@reduxjs/toolkit';

import { BusinessInfoState } from 'entities/businessInfo';
import { clearDashboard } from 'pages/dashboard/thunks';

import {
  fetchBusinessAdditionalData,
  updateCentralIndexDocument,
  updateBusinessDocument,
  uploadBusinessDocument,
  deleteBusinessDocument,
  updateBusinessInfo,
  fetchBusinessDocumentTypes,
  fetchBusinessLegalEntities,
} from './thunks';

export const initialState: BusinessInfoState = {
  documents: [],
  applicant: {
    applicantName: '',
    applicantEmail: '',
    applicantPhone: '',
    applicantRole: '',
    personsId: 0,
  },
  erpPreferences: null,
  isFormUpdate: false,
  showDoingBusinessAs: false,
  loadingProgress: 0,
  idTypes: [],
  legalEntityTypes: [],
  idTypesCountryId: 0,
  isSaving: false,
};

const businessInfoSlice = createSlice({
  name: 'businessInfo',
  initialState,
  reducers: {
    setFormUpdateState(state) {
      state.isFormUpdate = true;
    },
    setShowDoingBusinessAs(state, action) {
      state.showDoingBusinessAs = action.payload;
    },
    setLoadingProgress(state, action) {
      state.loadingProgress = action.payload;
    },
    setERPPreferences(state, action) {
      state.erpPreferences = action.payload;
    },
    setApplicant(state, action) {
      state.applicant = action.payload;
    },
    setIsSaving(state, action) {
      state.isSaving = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(clearDashboard, () => initialState);
    builder.addCase(fetchBusinessAdditionalData.fulfilled, (state, action) => {
      if (action.payload.documents) {
        state.documents = action.payload.documents;
      }

      if (action.payload.applicant) {
        state.applicant = action.payload.applicant;
      }

      if (action.payload.erpPreferences) {
        state.erpPreferences = action.payload.erpPreferences;
      }
    });
    builder.addCase(updateCentralIndexDocument.fulfilled, (state, action) => {
      state.documents = action.payload;
    });
    builder.addCase(updateBusinessDocument.fulfilled, (state, action) => {
      state.documents = action.payload;
    });
    builder.addCase(uploadBusinessDocument.fulfilled, (state, action) => {
      state.documents = action.payload;
    });
    builder.addCase(deleteBusinessDocument.fulfilled, (state, action) => {
      state.documents = action.payload;
    });
    builder.addCase(updateBusinessInfo.fulfilled, (state, action) => {
      state.isFormUpdate = action.payload;
    });
    builder.addCase(fetchBusinessDocumentTypes.pending, (state) => {
      state.idTypes = [];
    });
    builder.addCase(fetchBusinessDocumentTypes.fulfilled, (state, action) => {
      state.idTypes = action.payload.idTypes;
      state.idTypesCountryId = action.payload.idTypesCountryId;
    });
    builder.addCase(fetchBusinessLegalEntities.pending, (state) => {
      state.legalEntityTypes = [];
    });
    builder.addCase(fetchBusinessLegalEntities.fulfilled, (state, action) => {
      state.legalEntityTypes = action.payload.legalEntityTypes;
      state.idTypesCountryId = action.payload.idTypesCountryId;
    });
  },
});

export const {
  setFormUpdateState,
  setShowDoingBusinessAs,
  setLoadingProgress,
  setERPPreferences,
  setApplicant,
  setIsSaving,
} = businessInfoSlice.actions;

export default businessInfoSlice.reducer;
